import React from 'react';
import styles from './InputWrapper.module.scss';
import { joinClasses } from '../../../../../../Utils/className.util';
interface Props {
	children: React.ReactNode | React.ReactNode[];
	className?: string;
}

const InputWrapper: React.FC<Props> = ({ children, className }) => {
	return (
		<div className={joinClasses([styles.wrapper, className])}>{children}</div>
	);
};

export default InputWrapper;
